






































	import { Component } from "../../../Infrastructure/CorBase/CoreBase";
	import TagListBase from "./TagListBase";

	@Component
	export default class TagList extends TagListBase {		

		created() {
			super.initializeRights('COR_Tag_Create', 'COR_Tag_Delete', 'COR_Tag_Read', 'COR_Tag_Update');
			super.created();
            super.setDetailName('TagDetail');
            this.setDeleteMessage(this.$t('tag.messageQuestionMain').toString(), this.$t('tag.messageQuestionMain2').toString(), this.$t('tag.messageQuestionMain3').toString());

		};


		loadFilters(value: any) { super.loadFilters(value); }
		createNewClick(elementId: any) { super.createNewClick(elementId); }
		detailClick(elementId: any) {
            super.detailClick(elementId);
 		}

		goToReciver(item: any): void {
            this.$router.push({ name: item.pageDetail, params: { id: item.id.toString() }, query: { id: item.id.toString()} });
        }

		selectRows(items: any) {
			this.selectRowsBase(items);
		}


        showAllertToDeleteClick(itemsSelected: any) {
            this.countToRemove = itemsSelected != undefined ? ((typeof itemsSelected === 'number') ? 1 : (itemsSelected as Array<any>).length) : 1;
            if (this.$store.state.askBeforeDelete) {
               // super.showAlertBeforeActionClickBase(itemsSelected, this.$t('tag.messageQuestionMain').toString(), true);
                super.showAlertBeforeActionClickBase(itemsSelected, super.prepareRemoveMessage(), true);
            }
            else {
                this.itemsSelected = itemsSelected;
                this.callActionClick();
            }
        }

	};
